import type { AccountContact } from './types';

// Made-up contacts so the list can be reviewed before svc-contracting serves them. Delete with the API wiring.
export const SAMPLE_CONTACTS: ReadonlyArray<AccountContact> = [
  {
    id: 'sample-contact-1',
    name: 'Alex Example',
    title: 'Director of Sales and Marketing',
    email: 'alex.example@example.com',
    mobilePhone: '+61 400 555 001',
    phone: '+61 2 5550 1001',
  },
  {
    id: 'sample-contact-2',
    name: 'Blair Sample',
    title: 'Revenue Manager',
    email: 'blair.sample@example.com',
    mobilePhone: null,
    phone: '+61 2 5550 1002',
  },
  {
    id: 'sample-contact-3',
    name: 'Casey Placeholder',
    title: 'General Manager',
    email: 'casey.placeholder@example.com',
    mobilePhone: '+61 400 555 003',
    phone: null,
  },
  {
    id: 'sample-contact-4',
    name: 'Dana Test',
    title: 'Reservations Manager',
    email: 'dana.test@example.com',
    mobilePhone: null,
    phone: '+61 2 5550 1004',
  },
  {
    id: 'sample-contact-5',
    name: 'Emery Demo',
    title: 'Director, Global Distribution',
    email: 'emery.demo@example.com',
    mobilePhone: '+61 400 555 005',
    phone: '+61 2 5550 1005',
  },
  {
    id: 'sample-contact-6',
    name: 'Frankie Mock',
    title: 'Front Office Manager',
    email: null,
    mobilePhone: null,
    phone: '+61 2 5550 1006',
  },
  {
    id: 'sample-contact-7',
    name: 'Gale Specimen',
    title: null,
    email: 'gale.specimen@example.com',
    mobilePhone: null,
    phone: null,
  },
  {
    id: 'sample-contact-8',
    name: 'Harper Fixture',
    title: 'Finance Manager',
    email: 'harper.fixture@example.com',
    mobilePhone: '+61 400 555 008',
    phone: '+61 2 5550 1008',
  },
];
